"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resources = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Resources = typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({
    title: 'Resources',
    description: 'Resources associated with the message',
})));
